<template>
    <div class="box-container">
        <div id="home-section-five" class="container-size-fixer">
            <div id="title-one">
                برنامه های
                <span style="color: #cc171d">مهاجرت استانی کانادا،</span>
                راهی برای اقامت دائم با شرایط متنوع
            </div>
            <div id="description" v-if="explain">
             {{explain}}
            </div>
            <div v-if="homeLoadingMood">
                <img style="height: auto;width: 50%" src="../assets/loader/output-onlinegiftools.gif" alt="loader">
            </div>
            <div class="section-one-main-child" style="position: relative;margin-top: 50px">
                <div class="row" v-if="programs" style="margin-bottom: 50px">
                    <div v-for="program in programs" @click.prevent="$router.push('/category-view/'+program.slug)" class="col-lg-4 col-md-6 col-sm-12 immigration-program-information-box"  :key="program">
                        <div class="immigration-program-information-box-content">
                            <img :src="$store.state.base_urls.webUploads + program.symbol_image" alt="">
                            <div class="cover"></div>
                            <div class="text-container">{{program.name}}</div>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <img style="height: auto;width: 50%" src="../assets/loader/output-onlinegiftools.gif" alt="loader">
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import axios from 'axios'
    export default {
        name: "HomeSectionFive",
        props: ['explain','homeLoadingMood'],
        data(){
            return {
                programs: null,
            }
        },
        methods:{
            async getPageInfos() {
                try {
                    this.loadingMood = true;
                    let response = await axios.get('api/getMainCategories/ProvincialImmigrationPrograms',);
                    this.loadingMood = false;
                    this.programs = response.data.results;

                } catch (error) {
                    console.log(error)
                }
            },
        },
        mounted() {
            this.getPageInfos();
        },
    }
</script>

<style scoped lang="scss">
    .text-container{
        z-index: 200;
        position: relative;
        font-size: 20px;
        color: white;
        top: 40%;
    }
    .cover{
        position: absolute;
        opacity: 0.5;
        width: 100%;
        height: 100%;
        background-color: #1e1e21;
        z-index: 2;
        border-radius: 7px;
    }
    #space{
        width: 100%;
        height: 10px;
        background-color: #162336;
        margin-top: 80px;
    }
    #title-one{
        width: 100%;
        height: auto;
        font-size: 26px;
        font-weight: 600;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: normal;
        color: #1a1a1a;
        text-align: right;
    }
    #description{
        margin-top: 30px;
        width:100%;
        height: auto;
        font-size: 14px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: justify;
        color: #1a1a1a;
    }
    .box-container{
        margin-bottom: 10px;
        overflow: hidden;
        background-size: cover;
        background-repeat: no-repeat;
    }
    #home-section-five{
        padding: 50px 0;
        margin: auto;
        height: auto;
        width: 100%;
    }



    .immigration-program-information-box-content>img{
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        border-radius: 10px;
    }





    .immigration-program-information-box{
        height: 197px;
        /*002060*/
        padding: 15px;
    }
    .immigration-program-information-box-content{
        position: relative;
        width: 100%;
        height: 100%;
        border-radius: 10px;
        -webkit-backdrop-filter: blur(1px);
        backdrop-filter: blur(1px);
        box-shadow: 0 0 10px 0 rgba(255, 0, 0, 0.1);
        /*background-color: rgba(255, 255, 255, 0.7);*/
        border: solid 2px transparent;
        cursor: pointer;
        &:hover{
            border: solid 2px #fe7063;
        }
    }
    .section-one-main-child:nth-child(2){
        width: 100%;
        height: auto;
        padding: 50px 135px;
        /*opacity: 0.05;*/
        background-size: cover;
        background-repeat: no-repeat;
    }
    #home-section-two{
        width: 100%;
        height: auto;
    }
    #title{
        width: 100%;
        height: 57px;
        margin: 50px 0;
        font-family: 'IRANSans';
        font-size: 36px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: right;
        color: #1a1a1a;
    }
    @media (max-width: 1300px) {
        #home-section-five{
            padding: 15px;
        }

    }

</style>